import { Middleware } from "@nuxt/types"
import { CONSTANTS } from "@sohohouse/platform-resources"

import { isSitecoreRequest } from "~/utils/isSitecoreRequest"
import { CurrentUser } from "~/store/store.types"

const { SUBSCRIPTION_STATUSES } = CONSTANTS

export const SUBSCRIPTION_TYPE_ROUTES = {
  '': 'account-not-active',
  DEFAULT: 'account-not-active',
  [SUBSCRIPTION_STATUSES.APPROVED]: 'account-not-active',
  [SUBSCRIPTION_STATUSES.CURRENT]: 'account-not-active',
  [SUBSCRIPTION_STATUSES.EXPIRED]: 'account-expired',
  [SUBSCRIPTION_STATUSES.FROZEN]: 'account-frozen',
  [SUBSCRIPTION_STATUSES.RESIGNED]: 'account-not-active',
  [SUBSCRIPTION_STATUSES.SUSPENDED]: 'account-suspended',
  [SUBSCRIPTION_STATUSES.CHASING]: 'account-overdue'
}

export function getInvalidSubscriptionRoute ({ account, membership }: CurrentUser, error: Function) {
  if (membership && membership.nonMemberAccount) {
    error({ statusCode: 403 })
    return null
  }

  const { canAccessApp } = account

  if (!canAccessApp) {
    const { status = 'DEFAULT' } = membership || {}
    const membershipStatusRoute = SUBSCRIPTION_TYPE_ROUTES[status]

    return membershipStatusRoute
  }

  return null
}

const canAccessMemberApp: Middleware = ({ store, app, redirect, req, query, error }) => {
  if (isSitecoreRequest(req)) {
    return
  }

  const subscriptionRoute = getInvalidSubscriptionRoute(store.getters.currentUser, error)

  if (subscriptionRoute) {
    return redirect(app.localePath({ name: subscriptionRoute, query }))
  }
}

export default canAccessMemberApp
